export const editFinPassword = {
  finpasswd: {
    props: {
      type: 'password',
    },
  },

  finpasswd2: {
    props: {
      type: 'password',
    },
  },
}
